import React, { useEffect, useState, Fragment } from 'react';
import { AlarmClockIcon } from 'lucide-react';
const day = 24 * 60 * 60 * 1000;
function getTarget() {
  const saved = localStorage.getItem('dance-fitness-countdown-target');
  const parsed = saved ? Number(saved) : 0;
  if (parsed > Date.now()) return parsed;
  const target = Date.now() + day;
  localStorage.setItem('dance-fitness-countdown-target', String(target));
  return target;
}
function format(ms: number) {
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor(ms / 60000) % 60;
  const seconds = Math.floor(ms / 1000) % 60;
  return [hours, minutes, seconds].map(value => String(value).padStart(2, '0'));
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(day);
  useEffect(() => {
    let target = getTarget();
    const update = () => {
      if (target <= Date.now()) {
        target = Date.now() + day;
        localStorage.setItem('dance-fitness-countdown-target', String(target));
      }
      setRemaining(target - Date.now());
    };
    update();
    const interval = window.setInterval(update, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const [hours, minutes, seconds] = format(remaining);
  return <section aria-label="Launch price countdown" className="mx-auto mt-10 max-w-3xl rounded-2xl border border-orange/30 bg-soft p-6 text-center" data-id="element-56">
      <p className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-widest text-orange" data-id="element-57">
        <AlarmClockIcon size={18} data-id="element-58" /> Launch price countdown
      </p>
      <div className="mt-5 flex justify-center gap-2 sm:gap-4" data-id="element-59">
        {[[hours, 'hours'], [minutes, 'min'], [seconds, 'sec']].map(([value, label], index) => <Fragment key={label} data-id="element-60">
            <div className="min-w-20 rounded-xl border border-navy/15 bg-white px-3 py-3 sm:min-w-28" data-id="element-61">
              <strong className="block text-3xl tabular-nums text-navy sm:text-4xl" data-id="element-62">
                {value}
              </strong>
              <span className="text-xs text-slate-500" data-id="element-63">{label}</span>
            </div>
            {index < 2 && <span className="self-center text-2xl font-bold text-orange" data-id="element-64">
                :
              </span>}
          </Fragment>)}
      </div>
      <p className="mt-5 text-xs font-bold uppercase tracking-wider text-navy" data-id="element-65">
        Launch price: USD 27.00
      </p>
    </section>;
}